<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      save-button-text="确 定"
      title="机器设置"
      :data="data"
      :form-rules="rules"
      :save-func="saveFunc"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <div class="row-head">
          <el-checkbox v-model="data.设置工作状态">设置工作状态</el-checkbox>
        </div>
        <div class="border">
          <div class="box-row">
            <el-checkbox v-model="data.联机交易">联机交易</el-checkbox>
            <el-checkbox v-model="data.记账">记账</el-checkbox>
          </div>
        </div>
        <div class="row-head">
          <el-checkbox v-model="data.设置工作模式">设置工作模式</el-checkbox>
        </div>
        <div class="border">
          <div class="box-row">
            <el-checkbox v-model="data.输入金额">输入金额</el-checkbox>
            <el-checkbox v-model="data.定值金额">定值金额</el-checkbox>
          </div>
        </div>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        设置工作状态: false,
        联机交易: false,
        记账: false,
        设置工作模式: false,
        输入金额: false,
        定值金额: false,
      },
      api: require("@/api/sy/user").default,
      rules: {
        // 设备编号: [{ required: true, message: "设备编号不能为空" }],
        // 设备名称: [{ required: true, message: "设备名称不能为空" }],
        // 设备IP: [{ required: true, message: "设备IP不能为空" }],
        // 端口号: [{ required: true, message: "端口号不能为空" }],
        // 设备位置: [{ required: true, message: "设备位置不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      console.log("data", data);
    },
    saveFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: "保存成功", Data: null });
      });
    },
    onClosed() {
      this.data.有效考勤时段 = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.border {
  border-color: #ebeef5;
  .box-row {
    padding: 0 10px;
    line-height: 36px;
    .el-checkbox {
      width: 80px;
      margin-right: 5px;
    }
    .box-select {
      font-size: 14px;
      cursor: pointer;
      color: #409eff;
    }
  }
}
</style>